export const DOMAIN_REBUILD_ALERT_URL =
  'https://knowledge-base.yieldbird.com/yieldbird-platform/what-is-the-rebuild-process' as const
